var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loginsuccess-container"},[_c('Header',{attrs:{"pageName":_vm.pageName}}),_c('p',[_vm._v("404 Page not Found")]),_c('router-link',{attrs:{"to":"/login"}},[_vm._v("Go Back to Login")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }